import type { KnowledgeCardDetail } from "../../shared/api/types";
import { humanizeKey } from "../../shared/lib/format";
import { JsonView } from "../../shared/ui/JsonView";
import { Markdown } from "../../shared/ui/Markdown";
import { Badge } from "../../shared/ui/Primitives";

export function CardDetail({
  detail,
  onOpenCard,
}: {
  detail: KnowledgeCardDetail;
  onOpenCard: (id: string) => void;
}) {
  return (
    <div className="knowledge-detail">
      <div className="knowledge-detail__meta">
        <Badge tone="info">{detail.external_id}</Badge>
        <Badge tone={detail.reviewed ? "success" : "warning"}>
          {detail.reviewed ? "Проверена" : detail.status}
        </Badge>
        <span>Версия {detail.version_number}</span>
        <span>{detail.source_path}</span>
      </div>
      <section><h3>Свойства</h3><JsonView value={detail.properties} /></section>
      <section><h3>Содержание</h3><Markdown text={detail.body_markdown} onKnowledgeIdClick={onOpenCard} /></section>
      <section>
        <h3>Исходящие связи</h3>
        {detail.outgoing_edges.length ? (
          <div className="edge-list">
            {detail.outgoing_edges.map((edge, index) => (
              <button
                key={`${edge.relation_type}-${index}`}
                type="button"
                disabled={!edge.target_external_id}
                onClick={() => edge.target_external_id && onOpenCard(edge.target_external_id)}
              >
                <span>{humanizeKey(edge.relation_type)}</span>
                <strong>{edge.target_external_id || edge.target_reference}</strong>
                <Badge tone={edge.resolved ? "success" : "danger"}>{edge.resolved ? "Связана" : "Не разрешена"}</Badge>
              </button>
            ))}
          </div>
        ) : <p className="muted">Связи не указаны.</p>}
      </section>
      <details>
        <summary>Технические сведения</summary>
        <dl className="meta-list">
          <div><dt>Хеш</dt><dd><code>{detail.content_hash}</code></dd></div>
          <div><dt>ID версии</dt><dd><code>{detail.version_id}</code></dd></div>
        </dl>
      </details>
    </div>
  );
}
